import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { formatAccountNumber } from '@eika-infrastruktur/format';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { SummaryCard } from '@eika/card';
import { Link } from '@eika/link';
import { RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../../../defaultConfig';
import useTranslation, { formatJsx } from '../../../../hooks/useTranslation';
import { useSigningContext } from '../../../../signingContext/signingContext';
import { paymentTrackIDs } from '../../../../utils/gtm/trackIDs/payment';
import MoveAvtalegiroStatus from '../../components/MoveAvtalegiroStatus';
import { useAvtaleGiroMoveContext } from '../../context/AvtaleGiroMoveContext';

const MoveAvtaleGiroSummary: React.FC = () => {
    const translated = useTranslation();
    const { avtalegiroLink } = useConfig();
    const { dynamicLinkId } = useSigningContext();
    const navigate = useNavigate();
    const {
        moveAvtaleGiros,
        selectedDebitAccount,
        selectedAgreements: [selectedAgreements],
    } = useAvtaleGiroMoveContext();

    useEffect(() => {
        if (!dynamicLinkId) navigate('/');
    }, [dynamicLinkId, navigate]);

    if (moveAvtaleGiros.isError || moveAvtaleGiros.isSuccess || moveAvtaleGiros.isSomeError) {
        return <MoveAvtalegiroStatus />;
    }

    return (
        <>
            <section className="move-avtalegiro-form__form-content">
                <h2>{translated.moveAvtaleGiro.summary}</h2>
                <SummaryCard icon={RichIconTypes.STANDARISERING}>
                    <p>
                        {formatJsx(
                            translated.moveAvtaleGiro.youAreReadyToMove,
                            <span className="bold">
                                {selectedAgreements.length} {translated.transactionTypes.AUTOPAYMENT}
                            </span>,
                            <span className="bold">{selectedDebitAccount?.alias ?? ''}</span>,
                            <span className="bold">{formatAccountNumber(selectedDebitAccount?.accountNumber)}</span>,
                        )}
                    </p>
                </SummaryCard>
            </section>
            <section className="move-avtalegiro__action-button-wrapper">
                <ButtonWithSpinner
                    data-track-id={paymentTrackIDs.avtalegiro.moveAvtalegiros}
                    data-track-linkname={translated.moveAvtaleGiro.moveAvtaleGirosNow}
                    showSpinner={moveAvtaleGiros.isPending}
                    onClick={moveAvtaleGiros.mutate}
                >
                    {translated.moveAvtaleGiro.moveAvtaleGirosNow}
                </ButtonWithSpinner>
                {avtalegiroLink && <Link href={avtalegiroLink.url}>{translated.cancel}</Link>}
            </section>
        </>
    );
};

export default MoveAvtaleGiroSummary;
